module.exports = __webpack_public_path__ + "img/painting_jp.b0296b1.jpg";